import state from "./moduleCapacityState.js";
import mutations from "./moduleCapacityMutations.js";
import actions from "./moduleCapacityActions.js";
import getters from "./moduleCapacityGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
